import { useState, useRef } from "react";
import { Popover, Typography, Paper } from "@mui/material";

type ErrorMessagePopoverProps = {
	errorMessage: string;
	status: string;
};

export default function ErrorMessagePopover(props: Readonly<ErrorMessagePopoverProps>) {
	const { errorMessage, status } = props;
	const [anchorEl, setAnchorEl] = useState(null);
	const descriptionRef = useRef(null);
	const handleClick = () => {
		setAnchorEl(descriptionRef.current);
	};

	const handleClose = () => setAnchorEl(null);

	const open = Boolean(anchorEl);

	return (
		<Paper ref={descriptionRef} elevation={0} className={"!bg-transparent "}>
			<Typography
				onClick={handleClick}
				className={"capitalize underline cursor-pointer text-error !font-sans !text-[12px]"}
				component={"span"}
			>
				{status ?? ""}
			</Typography>

			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }} // just below the text
				transformOrigin={{ vertical: "top", horizontal: "left" }}
				slotProps={{ paper: { sx: { p: 1.5, maxWidth: 260, borderRadius: "6px" } } }} // small box styling
			>
				<Typography className="regular-pt-sans-pro-narrow-label fs-12">{errorMessage}</Typography>
			</Popover>
		</Paper>
	);
}
